import { render, staticRenderFns } from "./ViewTestApplication.vue?vue&type=template&id=47991fdc"
import script from "./ViewTestApplication.vue?vue&type=script&lang=js"
export * from "./ViewTestApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports